import React, { useEffect, useState } from 'react';
import {
    EuiOverlayMask,
    EuiButton,
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle,
} from '@elastic/eui';
import VariantAddonLinking from './varaintAddonLinking';
import { useSelector, useDispatch } from 'react-redux';
import * as types from '../../../reduxStore/types/menu';
import { isEmpty } from 'lodash';

const VariantAddonLinkModal = (props) => {
    const { setVaraintAddonLinkModalState, editItem, control, isOutletMenu } = props;

    const [variantAddonLinkState, setVariantAddonLinkState] = useState({});
    const variantGroup = useSelector((state) => state.menu.variantGroup);
    const variantAddonLink = useSelector((state) => state.menu.variantAddonLink);
    const dispatch = useDispatch();

    useEffect(() => {
        let innerObj = {};

        if (!isEmpty(variantAddonLink)) {
            innerObj = variantAddonLink;
        } else if (
            editItem.variants &&
            editItem.variants.length &&
            editItem.variants[0].options &&
            editItem.variants[0].options.length
        ) {
            editItem.variants[0].options.map((option) => {
                innerObj[option.id] = option.addons;
            });
        }

        setVariantAddonLinkState(innerObj);
    }, [editItem, variantAddonLink]);

    const closeModal = () => {
        setVaraintAddonLinkModalState(false);
    };

    const varinatOptionsList = () => {
        let optionsArray = [];
        if (variantGroup.length) {
            variantGroup.map((variant) => {
                optionsArray.push(
                    <VariantAddonLinking
                        variantAddonLinkState={variantAddonLinkState}
                        setVariantAddonLinkState={setVariantAddonLinkState}
                        control={control}
                        option={variant}
                        withVariant
                        isOutletMenu={isOutletMenu}
                    />
                );
            });
        } else if (
            editItem.variants &&
            editItem.variants.length &&
            editItem.variants[0].options &&
            editItem.variants[0].options.length
        ) {
            editItem.variants[0].options.map((option) => {
                optionsArray.push(
                    <VariantAddonLinking
                        variantAddonLinkState={variantAddonLinkState}
                        setVariantAddonLinkState={setVariantAddonLinkState}
                        control={control}
                        option={option}
                        isOutletMenu={isOutletMenu}
                    />
                );
            });
        }

        return optionsArray;
    };

    const onSave = () => {
        dispatch({
            type: types.SET_VARIANT_ADDON_LINK,
            payload: {
                variantAddonLink: variantAddonLinkState,
            },
        });

        closeModal();
    };

    return (
        <EuiOverlayMask>
            <EuiModal style={{ width: 800 }} onClose={closeModal}>
                <EuiModalHeader>
                    <EuiModalHeaderTitle>
                        <h1>Link Addon with Variant</h1>
                    </EuiModalHeaderTitle>
                </EuiModalHeader>

                <EuiModalBody>{varinatOptionsList()}</EuiModalBody>

                <EuiModalFooter>
                    <EuiButton onClick={closeModal}>Close</EuiButton>
                    {!isOutletMenu ? (
                        <EuiButton onClick={onSave} fill>
                            Save
                        </EuiButton>
                    ) : (
                        ''
                    )}
                </EuiModalFooter>
            </EuiModal>
        </EuiOverlayMask>
    );
};

export default VariantAddonLinkModal;
